import Axios from 'axios';
import {getHeaders} from '../../utills';
import Apis from '../Apis';
import StoreAction from '../Actions/StoreAction';
import GeneralAction from '../Actions/GeneralAction';
import AlertAction from '../Actions/AlertActions';

class StoreMiddleware {
  static getStore = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (userData?.search) {
            console.log('false');
            dispatch(StoreAction.ClearStoreList());
          }
          let formdata = new FormData();
          formdata.append('name', userData?.search);
          const {data} = await Axios.post(Apis.stores, formdata);
          if (data?.success) {
            dispatch(StoreAction.getStoreList(data));

            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static getInventory = () => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const {data} = await Axios.get(Apis.inventories);
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };
}

export default StoreMiddleware;
